import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import CreateProjectTab from './CreateProjectTab';
import { useCreateProjectPim } from 'lib/hooks/project/useCreateProjectPim';
import { Checkbox } from '@material-ui/core';
import { _color } from 'styles/_variables';
import CustomText from 'components/common/text/CustomText';

interface CreateProjectOptionPimProps {}

const CreateProjectOptionPim = ({}: CreateProjectOptionPimProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();
  const { upperJawChecked, lowerJawChecked, onCheckChange } = useCreateProjectPim();

  return (
    <StyledCreateProjectOptionPim>
      <div className="createProjectOptionPim__tab_container">
        <CreateProjectTab tabTitle={t('GLOBAL_PHOTOGRAMMETRY')} />
      </div>
      <div className="createProjectOptionPim__content">
        {/* 상악 */}
        <span className="option_checkbox" onClick={e => onCheckChange(e, 'upper')}>
          <Checkbox
            checked={upperJawChecked.value}
            className="checkbox_control_checkbox"
            color="primary"
            icon={<div className="custom_checkbox"></div>}
          />
          <CustomText fontSize={16} fontWeight={400} fontColor="#444">
            {t('PROJECT_OPTION_UPPER_JAW')}
          </CustomText>
        </span>
        {/* 하악 */}
        <span className="option_checkbox" onClick={e => onCheckChange(e, 'lower')}>
          <Checkbox
            checked={lowerJawChecked.value}
            className="checkbox_control_checkbox"
            color="primary"
            icon={<div className="custom_checkbox"></div>}
          />
          <CustomText fontSize={16} fontWeight={400} fontColor="#444">
            {t('PROJECT_OPTION_LOWER_JAW')}
          </CustomText>
        </span>
      </div>
    </StyledCreateProjectOptionPim>
  );
};

const StyledCreateProjectOptionPim = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  .createProjectOptionPim__tab_container {
  }
  .createProjectOptionPim__content {
    height: 100%;
    display: flex;
    padding: 30px 20px;
    column-gap: 20px;
    .option_checkbox {
      display: flex;
      column-gap: 10px;
      align-items: center;
      cursor: pointer;
      .custom_checkbox {
        width: 18px;
        height: 18px;
        border: 1px solid #e5e7ed;
        border-radius: 4px;
      }
      .MuiCheckbox-root {
        padding: 0;
        .MuiIconButton-label {
          width: 20px;
          height: 20px;
          color: ${_color.blue};
        }
      }
    }
  }
`;

export default CreateProjectOptionPim;
